import SecuredEval from './SecuredEval';
import SemiSecuredEval from './SemiSecuredEval';
import UnsecuredEval from './UnsecuredEval';

// Picks the evaluation template that matches the loan's pension state.
// Shared by every loan page (application, approved, active, completed,
// rejected) so the evaluation — and its Download button — stays reachable
// after a loan leaves the review pipeline.
function EvaluationPanel({ loan }) {
    const loanId = loan?._id;
    const loanType = loan?.type || loan?.loanType;

    if (loan?.pensionState === 'secured') {
        return <SecuredEval loanId={loanId} loanType={loanType} />;
    }
    if (loan?.pensionState === 'semi-secured') {
        return <SemiSecuredEval loanId={loanId} loanType={loanType} />;
    }
    return <UnsecuredEval loanId={loanId} loanType={loanType} pensionState={loan?.pensionState || ''} />;
}

export default EvaluationPanel;
